import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getUserDetails } from '../API/Api';

const VerificationMiddleware = ({ children, requireVerified = true }) => {
	const navigate = useNavigate();
	useEffect(() => {
		const checkVerification = async () => {
			try {
				const userData = await getUserDetails();
				if (userData.user?.verified !== 1) {
					//   toast.error('Please verify your account to access this page');
					navigate('/account-verification');
					return false;
				} else if (userData.user?.stelmart_status == 'Pending') {
					navigate('/account-pending-verification');
					return false;
				} else if (userData.user?.stelmart_status == 'Rejected') {
					navigate('/account-verification');
					return false;
				}
				return true;
			} catch (error) {
				console.error('Verification check failed:', error);
				return false;
			}
		};
		checkVerification();
	}, [navigate, requireVerified]);

	return children;
};

export default VerificationMiddleware;